import { useMemo } from 'react';
import type { Campaign } from 'src/common/interfaces/campaigns';
import { useGetUserQuery } from 'src/common/slices';

export const useCampaignCta = (campaign: Campaign | null): string => {
  const { data: userDataResponse } = useGetUserQuery();

  const isPremium = Boolean(userDataResponse?.data?.user?.isPremium);
  const campaignAmount = campaign?.amount ?? 0;

  return useMemo(() => {
    const isDiscountAvailable = campaignAmount > 0;

    if (isPremium && isDiscountAvailable) {
      return `Switch to annual & save ${campaignAmount}%`;
    }

    if (isDiscountAvailable) {
      return `Subscribe now & save ${campaignAmount}%`;
    }

    return 'Subscribe now';
  }, [isPremium, campaignAmount]);
};
